import {
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ResponsiveService } from '../services/responsive.service';
import { NGXLogger as LoggerService } from "ngx-logger";

/** Direction changes below this delta (px) are ignored: iOS bounce and trackpad
 *  micro-scrolls would otherwise toggle the bars constantly. */
const SCROLL_TOGGLE_THRESHOLD = 10;

@Component({
    selector: 'sticky-bar',
    standalone: true,
    templateUrl: './sticky-bar.component.html',
    styleUrls: ['./sticky-bar.component.scss'],
})
export class StickyBarComponent implements OnInit, OnDestroy {
    @ViewChild('stickyBars') stickyBars: ElementRef;
    @ViewChild('pageEnd') pageEnd: ElementRef;
    private previousScroll = 0;
    /** Scroll position the current hidden/visible state is anchored to — the
     *  reference the threshold is measured against. */
    private referenceScroll = 0;
    private hidden = false;
    private breakpointSubscription: Subscription;

    constructor(
        public responsiveService: ResponsiveService,
        private logger: LoggerService,
    ) { }

    ngOnInit(): void {
        // Hide-on-scroll is mobile-only. When the viewport grows past the small-screen
        // breakpoint while the bars are hidden, they have to come back — otherwise the
        // context-action-bar (the owner's primary touchpoint) stays invisible on desktop.
        this.breakpointSubscription = this.responsiveService.breakpointObserver
            .observe(['(min-width: 675px)'])
            .subscribe((state) => {
                if (state.matches) {
                    this.setHidden(false);
                }
            });
    }

    ngOnDestroy(): void {
        this.breakpointSubscription?.unsubscribe();
    }

    @HostListener('window:scroll', ['$event'])
    handleScroll() {
        if (!this.stickyBars) {
            return;
        }
        const currentScroll = window.scrollY;
        const scrollDirectionUp = currentScroll < this.previousScroll;
        this.previousScroll = currentScroll;

        // Desktop/tablet: never hide, and never touch the DOM from the scroll handler.
        if (!this.responsiveService.isScreenSmall()) {
            this.setHidden(false);
            this.referenceScroll = currentScroll;
            return;
        }

        // At the very top the bars always belong on screen.
        if (currentScroll <= 0) {
            this.setHidden(false);
            this.referenceScroll = currentScroll;
            return;
        }

        const shouldHide = this.isScrollBottom || !scrollDirectionUp;
        if (shouldHide === this.hidden) {
            // State confirmed: move the reference along so the threshold is always
            // measured from the furthest point reached in the current direction.
            this.referenceScroll = currentScroll;
            return;
        }
        if (Math.abs(currentScroll - this.referenceScroll) < SCROLL_TOGGLE_THRESHOLD) {
            return;
        }
        this.setHidden(shouldHide);
        this.referenceScroll = currentScroll;
    }

    /**
     * Writes the class only on an actual state change. Firefox warns about
     * scroll-linked positioning effects when a scroll handler restyles the element on
     * every event — with async panning (APZ) the JS write lags behind the compositor.
     */
    private setHidden(hidden: boolean): void {
        if (this.hidden === hidden || !this.stickyBars) {
            return;
        }
        this.hidden = hidden;
        this.stickyBars.nativeElement.classList.toggle('bars-hidden', hidden);
    }

    /**
     * If you scroll on the iphon to the bottom it scolls autmatically a little bit up again.
     * in this case we dont want to show the bars
     */
    private get isScrollBottom(): boolean {
        if (
            this.pageEnd.nativeElement.offsetTop - 30 <
            window.innerHeight + window.scrollY
        ) {
            //       this.logger.log('isScrollBottom true', this.pageEnd.nativeElement.offsetTop, window.innerHeight + window.scrollY)
            return true;
        } else {
            //     this.logger.log('isScrollBottom false')
            return false;
        }
    }

}
